import { useState } from "react";
import { saveCompletion } from "../services/completionSave";

export const useSaveCompletion = () => {
  const [isMutating, setIsMutating] = useState(false);

  const submit = async (args: Parameters<typeof saveCompletion>[0]) => {
    setIsMutating(true);
    try {
      await saveCompletion(args);
    } finally {
      setIsMutating(false);
    }
  };

  return { submit, isMutating };
};
